import { createElement } from "./dom_utils.js";

function createDownloadButton(options = {}) {
  const {
    attachment,
    styles = {},
  } = options;

  const {
    width = 24,
    height = 24,
    iconWidth = 16,
    iconHeight = 16,
    showByDefault = false,
  } = styles;

  const downloadButton = createElement("div", {
    className: "widget_attachment_action_btn",
    style: `
      display: ${showByDefault ? "flex" : "none"};
      align-items: center;
      justify-content: center;
      width: ${width}px;
      height: ${height}px;
      min-width: ${width}px;
      border-radius: 8px;
      cursor: pointer;
      flex-shrink: 0;
      background: rgba(0, 0, 0, 0.04);
      border: 1px solid rgba(0, 0, 0, 0.08);
      transition: background 0.2s ease;
    `,
  });

  const downloadIcon = createElement("img", {
    src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/download_file.svg",
    alt: "download",
    style: `width: ${iconWidth}px; height: ${iconHeight}px;`,
  });

  downloadButton.appendChild(downloadIcon);

  downloadButton.addEventListener("click", (e) => {
    e.stopPropagation();
    if (attachment.url) {
        window.open(attachment.url, "_blank");
    }
  });

  return downloadButton;
}

function addDownloadButtonHoverBehavior(container, downloadButton) {
  container.addEventListener("mouseenter", () => {
    downloadButton.style.display = "flex";
  });

  container.addEventListener("mouseleave", () => {
    downloadButton.style.display = "none";
  });
}

export { createDownloadButton, addDownloadButtonHoverBehavior };

